// extracted by mini-css-extract-plugin
export default {"loader":"loader-module__loader__3j4k+","loadingspin":"loader-module__loadingspin__uA7t2","loaderVisible":"loader-module__loaderVisible__ILSdc"};